(function () {
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $ac6739cbe5bf1c84$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}


function $f86983e96b0c893e$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $ea91727f98d0802f$export$71511d61b312f219(obj, privateSet) {
    (0, $f86983e96b0c893e$export$71511d61b312f219)(obj, privateSet);
    privateSet.add(obj);
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



function $fda036a8a0f9ba81$export$71511d61b312f219(receiver, classConstructor) {
    if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}


function $43fd461e54c387d7$export$71511d61b312f219(receiver, classConstructor, method) {
    (0, $fda036a8a0f9ba81$export$71511d61b312f219)(receiver, classConstructor);
    return method;
}


"use strict";
var $3d28d7f1aac198f5$var$MAX_FIELDS = 4;
var $3d28d7f1aac198f5$var$WIN_SCORE = 2048;
var $3d28d7f1aac198f5$var$_crateField = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_changeFinalStatus = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_isLose = /*#__PURE__*/ new WeakSet();
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_crateField);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_changeFinalStatus);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_isLose);
        // eslint-disable-next-line no-console
        console.log(initialState);
        if (Array.isArray(initialState) && initialState.length === $3d28d7f1aac198f5$var$MAX_FIELDS && initialState.every(function(e) {
            return e.length === $3d28d7f1aac198f5$var$MAX_FIELDS;
        })) {
            this.initialState = initialState;
            this.score = 0;
            this.status = "idle";
        }
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.getStatus() !== "lose") {
                    var previousState = JSON.stringify(this.initialState);
                    var _class_static_private_method_get_call = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$shiftLeft).call(Game, this.initialState), result = _class_static_private_method_get_call.result, score = _class_static_private_method_get_call.score;
                    this.score += score;
                    this.initialState = result;
                    if (previousState !== JSON.stringify(this.initialState)) (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_crateField, $3d28d7f1aac198f5$var$crateField).call(this);
                    (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_changeFinalStatus, $3d28d7f1aac198f5$var$changeFinalStatus).call(this);
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.getStatus() !== "lose") {
                    var previousState = JSON.stringify(this.initialState);
                    var tempMatrix = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$reverse).call(Game, this.initialState);
                    var _class_static_private_method_get_call = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$shiftLeft).call(Game, tempMatrix), result = _class_static_private_method_get_call.result, score = _class_static_private_method_get_call.score;
                    this.score += score;
                    this.initialState = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$reverse).call(Game, result);
                    if (previousState !== JSON.stringify(this.initialState)) (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_crateField, $3d28d7f1aac198f5$var$crateField).call(this);
                    (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_changeFinalStatus, $3d28d7f1aac198f5$var$changeFinalStatus).call(this);
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.getStatus() !== "lose") {
                    var previousState = JSON.stringify(this.initialState);
                    var tempMatrix = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$transposition).call(Game, this.initialState);
                    tempMatrix = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$reverse).call(Game, tempMatrix);
                    var _class_static_private_method_get_call = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$shiftLeft).call(Game, tempMatrix), result = _class_static_private_method_get_call.result, score = _class_static_private_method_get_call.score;
                    this.score += score;
                    tempMatrix = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$reverse).call(Game, result);
                    this.initialState = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$transposition).call(Game, tempMatrix);
                    if (previousState !== JSON.stringify(this.initialState)) (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_crateField, $3d28d7f1aac198f5$var$crateField).call(this);
                    (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_changeFinalStatus, $3d28d7f1aac198f5$var$changeFinalStatus).call(this);
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.getStatus() !== "lose") {
                    var previousState = JSON.stringify(this.initialState);
                    var tempMatrix = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$transposition).call(Game, this.initialState);
                    var _class_static_private_method_get_call = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$shiftLeft).call(Game, tempMatrix), result = _class_static_private_method_get_call.result, score = _class_static_private_method_get_call.score;
                    this.score += score;
                    this.initialState = (0, $43fd461e54c387d7$export$71511d61b312f219)(Game, Game, $3d28d7f1aac198f5$var$transposition).call(Game, result);
                    if (previousState !== JSON.stringify(this.initialState)) (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_crateField, $3d28d7f1aac198f5$var$crateField).call(this);
                    (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_changeFinalStatus, $3d28d7f1aac198f5$var$changeFinalStatus).call(this);
                }
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.initialState;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = "playing";
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_crateField, $3d28d7f1aac198f5$var$crateField).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_crateField, $3d28d7f1aac198f5$var$crateField).call(this);
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.initialState = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.status = "playing";
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_crateField, $3d28d7f1aac198f5$var$crateField).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_crateField, $3d28d7f1aac198f5$var$crateField).call(this);
            }
        }
    ]);
    return Game;
}();
function $3d28d7f1aac198f5$var$shiftLeft(matrix) {
    var _loop = function(i) {
        var row = result[i].filter(function(e) {
            return e !== 0;
        });
        for(var m = 0, n = m + 1; n < row.length; n++, m++)if (row[m] === row[n]) {
            row[m] *= 2;
            score += row[m];
            row[n] = 0;
        }
        row = row.filter(function(e) {
            return e !== 0;
        });
        while(result[i].length !== row.length)row.push(0);
        result[i] = row;
    };
    var score = 0;
    var result = structuredClone(matrix);
    for(var i = 0; i < result.length; i++)_loop(i);
    return {
        result: result,
        score: score
    };
}
function $3d28d7f1aac198f5$var$transposition(result) {
    var ref;
    for(var i = 0; i < result.length; i++)for(var j = i + 1; j < result[i].length; j++)ref = [
        result[j][i],
        result[i][j]
    ], result[i][j] = ref[0], result[j][i] = ref[1], ref;
    return result;
}
function $3d28d7f1aac198f5$var$reverse(matrix) {
    return matrix.map(function(r) {
        return (0, $227c6742e0ff6f82$export$71511d61b312f219)(r).reverse();
    });
}
function $3d28d7f1aac198f5$var$crateField() {
    var emptyCells = [];
    for(var i = 0; i < this.initialState.length; i++){
        for(var j = 0; j < this.initialState[i].length; j++)if (this.initialState[i][j] === 0) emptyCells.push({
            x: i,
            y: j
        });
    }
    if (emptyCells.length === 0) return;
    var randomIndex = Math.floor(Math.random() * emptyCells.length);
    var _emptyCells_randomIndex = emptyCells[randomIndex], x = _emptyCells_randomIndex.x, y = _emptyCells_randomIndex.y;
    this.initialState[x][y] = Math.random() > 0.9 ? 4 : 2;
}
function $3d28d7f1aac198f5$var$changeFinalStatus() {
    var hasWon = this.initialState.some(function(e) {
        return e.includes($3d28d7f1aac198f5$var$WIN_SCORE);
    });
    if (hasWon) {
        this.status = "win";
        return;
    }
    if ((0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_isLose, $3d28d7f1aac198f5$var$isLose).call(this)) this.status = "lose";
}
function $3d28d7f1aac198f5$var$isLose() {
    for(var i = 0; i < this.initialState.length; i++)for(var j = 0; j < this.initialState[i].length; j++){
        if (this.initialState[i][j] === 0) return false;
        if (j < this.initialState[i].length - 1 && this.initialState[i][j] === this.initialState[i][j + 1]) return false;
        if (i < this.initialState.length - 1 && this.initialState[i][j] === this.initialState[i + 1][j]) return false;
    }
    return true;
}
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$mainButton = document.querySelector(".button");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$previousState = null;
$197cd56b15c33885$var$mainButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$mainButton.classList.contains("start")) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$mainButton.textContent = "Restart";
        $197cd56b15c33885$var$mainButton.classList.remove("start");
        $197cd56b15c33885$var$mainButton.classList.add("restart");
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
    } else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$gameScore.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$update();
});
document.addEventListener("keydown", function(e) {
    e.preventDefault();
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
    }
    $197cd56b15c33885$var$update();
    switch($197cd56b15c33885$var$game.getStatus()){
        case "win":
            $197cd56b15c33885$var$messageWin.classList.remove("hidden");
            break;
        case "lose":
            $197cd56b15c33885$var$messageLose.classList.remove("hidden");
            break;
    }
});
function $197cd56b15c33885$var$update() {
    var fields = $197cd56b15c33885$var$game.getState();
    (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$gameField.rows).forEach(function(row, i) {
        (0, $227c6742e0ff6f82$export$71511d61b312f219)(row.cells).forEach(function(cell, j) {
            var currentValue = fields[i][j];
            var prevValue = $197cd56b15c33885$var$previousState ? $197cd56b15c33885$var$previousState[i][j] : 0;
            cell.textContent = "";
            cell.className = "field-cell";
            if (currentValue !== 0) {
                cell.textContent = currentValue;
                cell.classList.add("field-cell--".concat(currentValue));
                if (prevValue === 0) cell.classList.add("field-cell--new");
                else if (prevValue !== currentValue) cell.classList.add("field-cell--merged");
            }
        });
    });
    $197cd56b15c33885$var$gameScore.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$previousState = fields.map(function(row) {
        return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
    });
}

})();
//# sourceMappingURL=index.5af01285.js.map
